import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { LoadingComponent } from './loading.component';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  portal = new ComponentPortal(LoadingComponent);
  constructor(private overlay: Overlay) {}

  overlayRef = this.overlay.create({
    positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
    hasBackdrop: true
  });

  showLoader() {
    if (!this.overlayRef.hasAttached()) {
      this.overlayRef.attach(this.portal);
    }
    return of('');
  }

  hideLoader() {
    if (this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
    return of('');
  }
}
